import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import {
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
  useTheme,
  Paper,
  Box,
  Typography,
  Drawer,
  List,
  ListItem,
  Avatar,
  Divider,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import SearchIcon from '@material-ui/icons/Search';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PaymentIcon from '@material-ui/icons/Payment';
import ReceiptIcon from '@material-ui/icons/Receipt';
import CloseIcon from '@material-ui/icons/Close';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Skeleton from '@material-ui/lab/Skeleton';

import UIContainer from '../../../UI/Container/UIContainer';
import useApi from '../../../../utils/useApi';
import UIFormContainerSale from '../../../UI/Form/ContainerSale/UIFormContainerSale';
import SaleSearchItem from '../../Modal/searchItem';
import SaleMobileCatalog from '../../Mobile/SaleMobileCatalog';
import SaleMobileBottomBar from '../../Mobile/SaleMobileBottomBar';
import SaleMobileCartDrawer from '../../Mobile/SaleMobileCartDrawer';
import {
  emptyObject,
  formattedCurrency,
  maskedCurrency,
} from '../../../../utils/utils';
import SaleSelect from '../../Select/saleSelect';
import UIDialogConfirm from '../../../UI/Dialog/Confirm/UIDialogConfirm';
import SaleConfirm from '../Confirm/saleConfirm';
import { parseToledoPriceBarcode, parseLegacyWeightBarcode, calculateScaleItemQuantity } from '../../../../utils/scaleBarcodeParser';
import './saleNew.css';
import debounce from 'lodash.debounce';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f4f6f8',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('md')]: {
      height: '85vh',
      minWidth: 800,
    },
  },
  searchHeader: {
    flexShrink: 0,
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    zIndex: 2,
  },
  itemListContainer: {
    flexGrow: 1,
    overflowY: 'auto',
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(12),
    '-webkit-overflow-scrolling': 'touch',
  },
  mobileListItem: {
    backgroundColor: '#fff',
    borderRadius: 12,
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(2),
    boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  itemInfoArea: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    marginRight: theme.spacing(1),
    minWidth: 0,
  },
  itemAvatar: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    marginRight: theme.spacing(2),
    width: 40,
    height: 40,
  },
  itemTextContent: { minWidth: 0 },
  itemName: {
    fontWeight: 600,
    fontSize: '0.95rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  },
  qtyWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    minWidth: '100px',
  },
  qtyContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#f5f5f5',
    borderRadius: 24,
    padding: '2px',
    boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
  },
  qtyBtn: {
    padding: 6,
    backgroundColor: '#fff',
    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
    '&:hover': { backgroundColor: '#fff' }
  },
  qtyValue: {
    padding: '0 12px',
    fontWeight: 'bold',
    fontSize: '1rem',
    color: theme.palette.text.primary,
  },
  totalValueText: {
    marginTop: 4,
    fontWeight: 'bold',
    color: theme.palette.success.main,
    fontSize: '0.85rem',
  },
  bottomActionBar: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 -4px 12px rgba(0,0,0,0.05)',
    zIndex: 10,
  },
  checkoutButton: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    borderRadius: 25,
    fontWeight: 'bold',
    textTransform: 'none',
    fontSize: '1rem',
  },
  drawerPaper: {
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    height: '85vh',
    padding: theme.spacing(2),
    backgroundColor: '#fff',
  },
  drawerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
  },
  desktopWrapper: {
    flexGrow: 1,
    padding: theme.spacing(2),
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  desktopGrid: {
    height: '100%',
  },
  desktopPaper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: 8,
    backgroundColor: '#fff',
  },
  desktopHeader: {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    flexShrink: 0,
  },
  desktopScrollArea: {
    flexGrow: 1,
    overflowY: 'auto',
    minHeight: 0,
  },
  desktopFooter: {
    padding: theme.spacing(-1),
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    flexShrink: 0,
    backgroundColor: '#fafafa',
  }
}));

const initialOptions = {
  customer: null,
  plot: 1,
  promotion: null,
  totalGain: 0,
  discount: 0,
  total: 0,
  interest: 0,
  totalSum: 0,
  observation: '',
  paymentData: [],
};

const initialCalculate = {
  onlyCalculate: true,
  cashRegister: 1,
  customer: 1,
  products: {},
  services: {},
  plots: {},
  interest: 0,
  promotion: 1,
  setDiscount: null,
  splitRemaining: 0,
  session_id: '',
  identifier: '',
  responsible: '',
};

const ComandaQuantityStepper = ({ amount, onIncrement, onDecrement, onCommit }) => {
  const [localVal, setLocalVal] = useState(String(amount ?? 1));
  const [isLocked, setIsLocked] = useState(false);
  const lockTimerRef = useRef(null);

  useEffect(() => {
    setLocalVal(String(amount ?? 1));
  }, [amount]);

  useEffect(() => {
    return () => {
      if (lockTimerRef.current) clearTimeout(lockTimerRef.current);
    };
  }, []);

  const triggerLock = () => {
    setIsLocked(true);
    if (lockTimerRef.current) clearTimeout(lockTimerRef.current);
    lockTimerRef.current = setTimeout(() => {
      setIsLocked(false);
    }, 350);
  };

  const handleDecClick = () => {
    if (isLocked) return;
    triggerLock();
    onDecrement();
  };

  const handleIncClick = () => {
    if (isLocked) return;
    triggerLock();
    onIncrement();
  };

  const handleBlur = () => {
    const clean = String(localVal).trim().replace(',', '.');
    const num = parseFloat(clean);
    if (!isNaN(num) && num > 0) {
      const rounded = Math.round(num * 1000) / 1000;
      setLocalVal(String(rounded));
      onCommit(rounded);
    } else {
      setLocalVal(String(amount || 1));
      onCommit(amount || 1);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  };

  const handleChange = (e) => {
    const v = e.target.value;
    if (/^[0-9]*[.,]?[0-9]*$/.test(v) || v === '') {
      setLocalVal(v);
    }
  };

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#f1f5f9', borderRadius: 8, padding: '2px 4px' }}>
      <IconButton
        size="small"
        onClick={handleDecClick}
        disabled={isLocked}
        style={{
          padding: 4,
          backgroundColor: '#ffffff',
          borderRadius: 6,
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
          pointerEvents: isLocked ? 'none' : 'auto',
          opacity: isLocked ? 0.6 : 1,
        }}
        title="Diminuir quantidade"
      >
        <RemoveIcon style={{ fontSize: 14, color: '#475569' }} />
      </IconButton>
      <TextField
        type="text"
        size="small"
        value={localVal}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        inputProps={{
          inputMode: 'decimal',
          style: {
            fontSize: 14,
            fontWeight: 700,
            textAlign: 'center',
            width: 46,
            padding: '4px 2px',
            color: '#1e293b',
          },
        }}
        InputProps={{
          disableUnderline: true,
        }}
      />
      <IconButton
        size="small"
        onClick={handleIncClick}
        disabled={isLocked}
        style={{
          padding: 4,
          backgroundColor: '#ffffff',
          borderRadius: 6,
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
          pointerEvents: isLocked ? 'none' : 'auto',
          opacity: isLocked ? 0.6 : 1,
        }}
        title="Aumentar quantidade"
      >
        <AddIcon style={{ fontSize: 14, color: '#475569' }} />
      </IconButton>
    </div>
  );
};

const SaleNew = (children) => {
  const { saleMetadata, refreshCards, handleModalSale } = children;
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [loading, setLoading] = useState(true);
  const [qntd, setQntd] = useState(1);

  const [cartValues, setCartValues] = useState(() => ({
    ...initialOptions,
    customer: saleMetadata?.customerData || (saleMetadata?.customer ? { id: saleMetadata.customer } : null),
    ...saleMetadata?.sale_metadata,
  }));
  const [listItens, setListItems] = useState([]);
  const [calculate, setCalculate] = useState(initialCalculate);
  const [barCode, setBarCode] = useState('');

  const [modalConfirm, setModalConfirm] = useState(false);
  const [modalSearch, setModalSearch] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [alertList, setAlertList] = useState(false);
  const [itemToRemove, setItemToRemove] = useState(null);
  const lastItemActionRef = useRef({ time: 0, key: '' });

  function handleConfirmRemove() {
    if (itemToRemove !== null) {
      removeItem(itemToRemove.index);
    }
    setItemToRemove(null);
  }

  const [salesLoad, salesInfo, setSaleInfo] = useApi({
    method: 'put',
    url: '/sales/sessions',
  });

  const [salesSessionsLoad] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/sales/sessions',
  });

  const [searchProductLoad] = useApi({ debounceDelay: 500, method: 'get', url: '/products' });
  const [searchServicesLoad] = useApi({ debounceDelay: 500, method: 'get', url: '/services' });

  const toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setDrawerOpen(open);
  };

  function changeSearchItens() {
    setModalSearch(!modalSearch);
  }

  useEffect(() => {
    const fetchAndOrganizeData = async () => {
      salesSessionsLoad({
        params: { session_id: saleMetadata.session_id },
        onCompleted: async (res) => {
          if (res) {
            setLoading(true);
            const { data } = res;
            const value = data[0];
            const { products, services } = value;

            const formCalculate = {
              onlyCalculate: true,
              cashRegister: value.cashRegister,
              customer: value.customer,
              products: value.products,
              services: value.services,
              plots: value.plots,
              interest: value.interest,
              promotion: value.promotion,
              setDiscount: value.sale_metadata?.discount,
              splitRemaining: value.splitRemaining ? 1 : 0,
              session_id: value.session_id,
              identifier: value.identifier,
              responsible: value.responsible,
              observation: `${value.identifier} - ${value.responsible}`,
            };

            const formSaleOptions = {
              ...value.sale_metadata,
              customer: value.customerData,
              plots: value.plots,
              promotion: value.sale_metadata?.promotion,
              totalGain: value.sale_metadata?.totalSum,
              discount: value.sale_metadata?.discount,
              total: value.sale_metadata?.total,
              interest: value.interest?.percentage || value.interest || 0,
              totalSum: value.sale_metadata?.totalSum,
              observation: `${value.identifier} - ${value.responsible}`,
              paymentData: [],
              products: value.sale_metadata?.products || [],
              services: value.sale_metadata?.services || [],
            };

            const productIds = products ? Object.keys(products).filter((id) => id && products[id] > 0) : [];
            const serviceIds = services ? Object.keys(services).filter((id) => id && services[id] > 0) : [];

            const productPromise = productIds.length > 0
              ? new Promise((resolve) => {
                  searchProductLoad({
                    params: { ids: productIds },
                    onCompleted: (tmpRes) => {
                      if (tmpRes && tmpRes.data && tmpRes.data.length > 0) {
                        const mapped = tmpRes.data.map((tmpData) => {
                          const pId = String(tmpData.id);
                          const qty = products[pId] || products[Number(pId)] || 1;
                          return {
                            id: parseInt(tmpData.id),
                            amount: qty,
                            name: tmpData.name,
                            valueUn: tmpData.value,
                            valueTotal: tmpData.value * qty,
                            typeItem: 'product',
                            barCode: tmpData.barCode,
                            category: tmpData.category,
                          };
                        });
                        resolve(mapped);
                      } else {
                        resolve([]);
                      }
                    },
                  });
                })
              : Promise.resolve([]);

            const servicePromise = serviceIds.length > 0
              ? new Promise((resolve) => {
                  searchServicesLoad({
                    params: { ids: serviceIds },
                    onCompleted: (tmpRes) => {
                      if (tmpRes && tmpRes.data && tmpRes.data.length > 0) {
                        const mapped = tmpRes.data.map((tmpData) => {
                          const sId = String(tmpData.id);
                          const qty = services[sId] || services[Number(sId)] || 1;
                          return {
                            id: parseInt(tmpData.id),
                            amount: qty,
                            name: tmpData.name,
                            valueUn: tmpData.value,
                            valueTotal: tmpData.value * qty,
                            typeItem: 'service',
                            barCode: tmpData.barCode,
                            category: tmpData.category,
                          };
                        });
                        resolve(mapped);
                      } else {
                        resolve([]);
                      }
                    },
                  });
                })
              : Promise.resolve([]);

            const [fetchedProducts, fetchedServices] = await Promise.all([productPromise, servicePromise]);
            const combinedList = [
              ...fetchedProducts.filter((item) => item !== undefined),
              ...fetchedServices.filter((item) => item !== undefined),
            ];

            setCartValues(formSaleOptions);
            setCalculate(formCalculate);
            setListItems(combinedList);
            setLoading(false);
          }
        },
      });
    };
    fetchAndOrganizeData();
  }, [saleMetadata]);

  function searchBarCode(value) {
    setBarCode(value);

    // Detecção inteligente modular de código de balança (Toledo Preço Total + Fallback Legado por Peso)
    const scaleFallbackData = parseToledoPriceBarcode(value) || parseLegacyWeightBarcode(value);
    if (scaleFallbackData) {
      const targetPlu = scaleFallbackData.plu || (scaleFallbackData.candidates && scaleFallbackData.candidates[0]?.plu);
      if (targetPlu) {
        searchProductLoad({
          params: { id: targetPlu, lacking: 0 },
          onCompleted: (res) => {
            if (res && res.data && res.data.length > 0) {
              const data = res.data[0];
              const isLacking = data.lacking === true || data.lacking === 1 || data.lacking === '1';
              if (isLacking) return;
              let scaleQty = 1;
              if (scaleFallbackData.mode === 'price') {
                scaleQty = calculateScaleItemQuantity(scaleFallbackData.totalPrice, data.value);
              } else if (scaleFallbackData.candidates && scaleFallbackData.candidates[0]) {
                scaleQty = scaleFallbackData.candidates[0].weight;
              }
              selectItem({
                id: data.id,
                amountSelected: scaleQty,
                name: data.name,
                value: data.value,
                barCode: data.barCode,
                typeItem: 'product',
                category: data.category,
              });
              setQntd(1);
            }
          },
        });
        return;
      }
    }

    searchProductLoad({
      params: { barCode: value, lacking: 0 },
      onCompleted: (res) => {
        if (res && res.data && res.data.length > 0) {
          const data = res.data[0];
          const isLacking = data.lacking === true || data.lacking === 1 || data.lacking === '1';
          if (isLacking) return;
          selectItem({
            id: data.id,
            amountSelected: 1,
            name: data.name,
            value: data.value,
            barCode: data.barCode,
            typeItem: 'product',
            category: data.category,
          });
          setQntd(1);
        }
      },
    });
    searchServicesLoad({
      params: { barCode: value, isActive: 1 },
      onCompleted: (res) => {
        if (res && res.data.length > 0) {
          const data = res.data[0];
          if (data.isActive === false || data.isActive === 0 || data.isActive === '0') return;
          selectItem({
            id: data.id,
            amountSelected: qntd,
            name: data.name,
            value: Number(data.value),
            barCode: data.barCode,
            typeItem: 'service',
            category: data.category,
          });
          setQntd(1);
        }
      },
    });
  }

  function checkCart(list = listItens) {
    const allProducts = list.filter((value) => value.typeItem === 'product');
    const allServices = list.filter((value) => value.typeItem === 'service');

    const products = allProducts.reduce((acc, { id, amount }) => {
      acc[id] = (acc[id] || 0) + Number(amount);
      return acc;
    }, {});
    const services = allServices.reduce((acc, { id, amount }) => {
      acc[id] = (acc[id] || 0) + Number(amount);
      return acc;
    }, {});

    return emptyObject({ ...calculate, products, services });
  }

  function selectItem(values) {
    addItem({
      id: values.id,
      amount: values.amountSelected,
      name: values.name,
      valueUn: values.value,
      valueTotal: values.value * values.amountSelected,
      typeItem: values.typeItem,
      barCode: values.barCode,
      category: values.category ? (typeof values.category === 'object' ? values.category.id : values.category) : null,
    });
  }

  const debouncedSyncSession = useCallback(
    debounce((data, previousItems, previousCartValues) => {
      salesLoad({
        data: emptyObject(data),
        onCompleted: (res) => {
          if (res && res.data) {
            setCartValues((prev) => ({ ...prev, ...res.data.sale_metadata }));
            refreshCards({});
          }
        },
        onError: () => {
          setAlertList(true);
          if (previousItems) {
            setListItems(previousItems);
            setCalculate((prev) => ({ ...prev, ...checkCart(previousItems) }));
          }
          if (previousCartValues) {
            setCartValues(previousCartValues);
          }
        },
      });
    }, 400),
    [salesLoad, refreshCards]
  );

  function addItem(values) {
    if (values.name) {
      const now = Date.now();
      const itemKey = `add-${values.id || values.barCode || values.name}`;
      if (now - lastItemActionRef.current.time < 350 && lastItemActionRef.current.key === itemKey) {
        return;
      }
      lastItemActionRef.current = { time: now, key: itemKey };

      const prevItems = [...listItens];
      const prevCart = { ...cartValues };

      const checkDuplicateIndex = listItens.findIndex(
        (cv) => (cv.barCode && values.barCode && cv.barCode === values.barCode) ||
                (String(cv.id) === String(values.id) && cv.typeItem === values.typeItem)
      );

      let testItens;
      if (checkDuplicateIndex !== -1) {
        const newAmount = listItens[checkDuplicateIndex].amount + values.amount;
        testItens = listItens.map((it, idx) => {
          if (idx === checkDuplicateIndex) {
            return {
              ...it,
              amount: newAmount,
              valueTotal: newAmount * Number(it.valueUn),
            };
          }
          return it;
        });
      } else {
        testItens = [...listItens, values];
      }

      // Atualização local imediata (0ms)
      const subtotal = testItens.reduce((sum, it) => sum + Number(it.amount || 0) * Number(it.valueUn || 0), 0);
      const total = Math.max(0, subtotal - Number(cartValues.discount || 0));
      setListItems(testItens);
      setCartValues((prev) => ({ ...prev, total, totalSum: subtotal }));
      setBarCode('');

      const data = checkCart(testItens);
      setCalculate((prev) => ({ ...prev, ...data }));
      debouncedSyncSession(data, prevItems, prevCart);
    }
  }

  function editItem(index, value) {
    if (value >= 0) {
      const now = Date.now();
      const itemKey = `edit-${index}`;
      if (now - lastItemActionRef.current.time < 350 && lastItemActionRef.current.key === itemKey) {
        return;
      }
      lastItemActionRef.current = { time: now, key: itemKey };

      const prevItems = [...listItens];
      const prevCart = { ...cartValues };

      let newItems;
      if (value === 0) {
        newItems = listItens.filter((_, idx) => idx !== index);
      } else {
        newItems = listItens.map((item, idx) => {
          if (idx === index) {
            return {
              ...item,
              amount: value,
              valueTotal: Number(value) * Number(item.valueUn),
            };
          }
          return item;
        });
      }

      // Atualização local imediata (0ms)
      const subtotal = newItems.reduce((sum, it) => sum + Number(it.amount || 0) * Number(it.valueUn || 0), 0);
      const total = Math.max(0, subtotal - Number(cartValues.discount || 0));
      setListItems(newItems);
      setCartValues((prev) => ({ ...prev, total, totalSum: subtotal }));

      const data = checkCart(newItems);
      setCalculate((prev) => ({ ...prev, ...data }));
      debouncedSyncSession(data, prevItems, prevCart);
    }
  }

  function removeItem(index) {
    const now = Date.now();
    const itemKey = `remove-${index}`;
    if (now - lastItemActionRef.current.time < 350 && lastItemActionRef.current.key === itemKey) {
      return;
    }
    lastItemActionRef.current = { time: now, key: itemKey };

    const prevItems = [...listItens];
    const prevCart = { ...cartValues };

    const newItems = listItens.filter((_, idx) => idx !== index);
    const subtotal = newItems.reduce((sum, it) => sum + Number(it.amount || 0) * Number(it.valueUn || 0), 0);
    const total = Math.max(0, subtotal - Number(cartValues.discount || 0));
    setListItems(newItems);
    setCartValues((prev) => ({ ...prev, total, totalSum: subtotal }));

    const data = checkCart(newItems);
    setCalculate((prev) => ({ ...prev, ...data }));
    debouncedSyncSession(data, prevItems, prevCart);
  }

  function selectClient(value) {
    setCartValues({ ...cartValues, customer: value || null });
    setCalculate({ ...calculate, customer: value?.id || null });
    salesLoad({ data: emptyObject({ ...calculate, customer: value?.id || null }) });
  }

  function selectPlots(value) {}

  function confirmSale() {
    salesLoad({
      data: checkCart(listItens),
      onCompleted: (res) => {
        if (res) {
          const newPayment = {
            amountPaid: maskedCurrency(res.data.sale_metadata.total.toFixed(2)),
            paymentMethod: '3',
          };
          const updatedCart = {
            ...cartValues,
            ...res.data.sale_metadata,
            paymentData: [newPayment],
          };
          setCartValues(updatedCart);
          
          setModalConfirm(true);
          setDrawerOpen(false);
          refreshCards({});
        } else {
          setAlertList(true);
        }
      },
    });
  }

  function resetform() {
    setCartValues(initialOptions);
    setCalculate(initialCalculate);
    setListItems([]);
    setModalConfirm(false);
    handleModalSale();
  }

  function selectPromotion(value) {
    salesLoad({
      data: emptyObject({ ...calculate, promotion: value && value.id }),
      onCompleted: (res) => {
        if (res) {
          setCartValues({ ...cartValues, ...res.data.sale_metadata });
          setCalculate({ ...calculate, promotion: value && value.id });
          refreshCards({});
        } else {
          setAlertList(true);
        }
      },
    });
  }

  function setDiscount(value) {
    const discount = typeof value === 'number'
      ? value
      : Number(String(value || 0).replace(/\./g, '').replace(',', '.'));

    salesLoad({
      data: emptyObject({ ...calculate, setDiscount: discount }),
      onCompleted: (res) => {
        if (res) {
          setCartValues({ ...cartValues, ...res.data.sale_metadata, discount, setDiscount: discount });
          setCalculate({ ...calculate, setDiscount: discount });
        } else {
          setAlertList(true);
          setCartValues({ ...cartValues, setDiscount: null });
        }
      },
    });
  }

  function selectInterest(value) {
    if (value >= 0 && value <= 100) {
      const percentage = Number(value) || 0;
      const objInterest = {
        percentage,
        type: 'simples',
      };
      const subtotal = Number(cartValues.totalSum || 0);
      const discount = Number(cartValues.discount || 0);
      const base = Math.max(0, subtotal - discount);
      const increase = (base * percentage) / 100;
      const total = base + increase;

      setCartValues((prev) => ({
        ...prev,
        interest: percentage,
        increase,
        total,
      }));
      setCalculate((prev) => ({
        ...prev,
        interest: objInterest,
      }));
      refreshCards({});
    }
  }

  if (loading) {
    if (mobile) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', maxHeight: '100dvh', backgroundColor: '#f8fafc', overflow: 'hidden' }}>
          {/* Header Skeleton */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '10px 16px',
            backgroundColor: '#17497f',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <Skeleton variant="circle" width={28} height={28} style={{ backgroundColor: 'rgba(255,255,255,0.2)' }} />
              <div>
                <Skeleton variant="text" width={110} height={22} style={{ backgroundColor: 'rgba(255,255,255,0.3)' }} />
                <Skeleton variant="text" width={75} height={14} style={{ backgroundColor: 'rgba(255,255,255,0.2)' }} />
              </div>
            </div>
            <Skeleton variant="rect" width={80} height={24} style={{ borderRadius: 6, backgroundColor: 'rgba(255,255,255,0.25)' }} />
          </div>

          {/* Search Bar Skeleton */}
          <div style={{ padding: '12px 14px 6px 14px', backgroundColor: '#ffffff' }}>
            <Skeleton variant="rect" height={40} style={{ borderRadius: 10 }} />
            <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
              <Skeleton variant="rect" width={75} height={28} style={{ borderRadius: 14 }} />
              <Skeleton variant="rect" width={105} height={28} style={{ borderRadius: 14 }} />
              <Skeleton variant="rect" width={90} height={28} style={{ borderRadius: 14 }} />
            </div>
          </div>

          {/* Items List Skeleton */}
          <div style={{ flex: 1, padding: '8px 12px', display: 'flex', flexDirection: 'column', gap: 8, overflowY: 'hidden' }}>
            {[1, 2, 3, 4, 5, 6, 7].map((n) => (
              <div
                key={n}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '12px 14px',
                  backgroundColor: '#ffffff',
                  borderRadius: 12,
                  border: '1px solid #e2e8f0',
                }}
              >
                <div style={{ flex: 1 }}>
                  <Skeleton variant="text" width="65%" height={20} />
                  <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                    <Skeleton variant="text" width={60} height={16} />
                    <Skeleton variant="rect" width={50} height={16} style={{ borderRadius: 4 }} />
                  </div>
                </div>
                <Skeleton variant="rect" width={76} height={32} style={{ borderRadius: 18 }} />
              </div>
            ))}
          </div>

          {/* Bottom Bar Skeleton */}
          <div style={{
            padding: '12px 16px',
            backgroundColor: '#0f172a',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
            <div>
              <Skeleton variant="text" width={90} height={14} style={{ backgroundColor: 'rgba(255,255,255,0.2)' }} />
              <Skeleton variant="text" width={110} height={26} style={{ backgroundColor: 'rgba(255,255,255,0.3)' }} />
            </div>
            <Skeleton variant="rect" width={130} height={40} style={{ borderRadius: 10, backgroundColor: 'rgba(255,255,255,0.25)' }} />
          </div>
        </div>
      );
    }

    return (
      <div className={classes.root} style={{ padding: 16, boxSizing: 'border-box' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Skeleton variant="rect" height={50} style={{ borderRadius: 8, marginBottom: 16 }} />
            <Skeleton variant="rect" height={380} style={{ borderRadius: 8 }} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Skeleton variant="rect" height={446} style={{ borderRadius: 8 }} />
          </Grid>
        </Grid>
      </div>
    );
  }

  if (mobile) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          maxHeight: '100dvh',
          width: '100%',
          backgroundColor: '#f4f6f9',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Header da Comanda Mobile */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 16px',
          backgroundColor: '#17497f',
          color: '#ffffff',
          boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
          zIndex: 30,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <IconButton
              size="small"
              onClick={() => handleModalSale()}
              style={{ color: '#ffffff', padding: 4 }}
            >
              <ArrowBackIcon />
            </IconButton>
            <div>
              <div style={{ fontSize: '0.95rem', fontWeight: 800 }}>
                {saleMetadata?.identifier || 'Comanda'}
              </div>
              <div style={{ fontSize: '0.72rem', opacity: 0.85 }}>
                {saleMetadata?.responsible || 'Atendimento'}
              </div>
            </div>
          </div>
          <div style={{ fontSize: '0.95rem', fontWeight: 900, color: '#a7f3d0' }}>
            {formattedCurrency(cartValues.total || 0)}
          </div>
        </div>

        {/* Catálogo Rápido */}
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <SaleMobileCatalog
            listItens={listItens}
            onSelectItem={selectItem}
            onEditItem={editItem}
            onRemoveItem={removeItem}
            onBarCodeSubmit={searchBarCode}
          />
        </div>

        {/* Barra Fixa Inferior */}
        <SaleMobileBottomBar
          listItens={listItens}
          total={cartValues.total}
          onOpenCart={() => setDrawerOpen(true)}
          actionText="Ver Comanda"
        />

        {/* Gaveta de Itens da Comanda */}
        <SaleMobileCartDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          listItens={listItens}
          cartValues={cartValues}
          manualDiscount={cartValues.discount || cartValues.setDiscount || 0}
          onEditItem={editItem}
          onRemoveItem={removeItem}
          onSelectCustomer={selectClient}
          onSelectPromotion={selectPromotion}
          onSetDiscount={setDiscount}
          onSetObservation={(obs) => setCartValues((prev) => ({ ...prev, observation: obs }))}
          onProceedCheckout={confirmSale}
          checkoutButtonText="Encerrar / Pagar Comanda"
        />

        {/* Modal de Confirmação / Pagamento */}
        {modalConfirm && (
          <SaleConfirm
            open={modalConfirm}
            options={cartValues}
            calculate={calculate}
            setOptions={setCartValues}
            handleModal={() => setModalConfirm(!modalConfirm)}
            resetform={resetform}
            mobile={mobile}
          />
        )}

        <UIDialogConfirm
          open={alertList}
          data={salesInfo}
          timeSucess={3000}
          messageSucess="Ação realizada com sucesso!"
          close={() => setAlertList(!alertList)}
          setrequestinfo={setSaleInfo}
        />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.searchHeader}>
        <TextField
            value={barCode}
            autoComplete="off"
            variant="outlined"
            size="small"
            placeholder={mobile ? "Código ou nome..." : "Adicionar produto"}
            onChange={(ev) => searchBarCode(ev.target.value)}
            fullWidth
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon color="action" />
                    </InputAdornment>
                ),
                endAdornment: (
                <InputAdornment position="end">
                    <IconButton size="small" onClick={changeSearchItens}>
                         <ReceiptIcon color="primary" />
                    </IconButton>
                </InputAdornment>
                ),
            }}
        />
      </div>

      {mobile ? (
        <>
            <div className={classes.itemListContainer}>
                {listItens.length === 0 ? (
                    <Box textAlign="center" mt={4} color="text.secondary">
                        <ShoppingCartIcon style={{ fontSize: 60, opacity: 0.2 }} />
                        <Typography variant="h6">Carrinho Vazio</Typography>
                        <Typography variant="body2">Use a busca acima para adicionar itens</Typography>
                    </Box>
                ) : (
                    <List disablePadding>
                        {listItens.map((item, index) => {
                          const calcList = item.typeItem === 'product' ? cartValues.products : cartValues.services;
                          const calcItem = Array.isArray(calcList)
                            ? calcList.find((it) => String(it.id) === String(item.id))
                            : null;
                          const hasDiscount = calcItem && Number(calcItem.discount) > 0;

                          return (
                            <ListItem key={index} className={classes.mobileListItem} disableGutters>
                                <div className={classes.itemInfoArea}>
                                    <Avatar className={classes.itemAvatar}>
                                        {item.name ? item.name.substring(0, 1).toUpperCase() : '#'}
                                    </Avatar>
                                    <div className={classes.itemTextContent}>
                                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
                                          <Typography variant="body1" className={classes.itemName}>
                                              {item.name}
                                          </Typography>
                                          {hasDiscount && (
                                            <span
                                              style={{
                                                fontSize: '0.7rem',
                                                backgroundColor: '#E8F5E9',
                                                color: '#2E7D32',
                                                padding: '1px 5px',
                                                borderRadius: 4,
                                                fontWeight: 600,
                                              }}
                                            >
                                              -{formattedCurrency(calcItem.discount)}
                                            </span>
                                          )}
                                        </div>
                                        <Typography variant="caption" color="textSecondary">
                                            Unit: {formattedCurrency(item.valueUn)}
                                        </Typography>
                                    </div>
                                </div>
                                <div className={classes.qtyWrapper}>
                                    <div className={classes.qtyContainer}>
                                        <IconButton size="small" className={classes.qtyBtn} onClick={() => item.amount > 1 ? editItem(index, Number(item.amount) - 1) : removeItem(index)}>
                                            <RemoveIcon style={{ fontSize: 16 }} />
                                        </IconButton>
                                        <span className={classes.qtyValue}>{item.amount}</span>
                                        <IconButton size="small" className={classes.qtyBtn} onClick={() => editItem(index, Number(item.amount) + 1)}>
                                            <AddIcon style={{ fontSize: 16 }} />
                                        </IconButton>
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                      {hasDiscount ? (
                                        <div>
                                          <span style={{ textDecoration: 'line-through', color: '#9E9E9E', fontSize: '0.75rem', marginRight: 4 }}>
                                            {formattedCurrency(item.valueTotal)}
                                          </span>
                                          <Typography className={classes.totalValueText} style={{ color: '#1B5E20', display: 'inline', fontWeight: 700 }}>
                                            {formattedCurrency(calcItem.total)}
                                          </Typography>
                                        </div>
                                      ) : (
                                        <Typography className={classes.totalValueText}>
                                            {formattedCurrency(item.valueTotal)}
                                        </Typography>
                                      )}
                                    </div>
                                </div>
                            </ListItem>
                          );
                        })}
                    </List>
                )}
            </div>
            <Paper className={classes.bottomActionBar} square elevation={3}>
                <Box>
                    <Typography variant="caption" color="textSecondary" display="block">Total a pagar</Typography>
                    <Typography variant="h5" style={{ fontWeight: 'bold', color: theme.palette.success.main }}>
                        {formattedCurrency(cartValues.total)}
                    </Typography>
                </Box>
                <Button 
                    variant="contained" 
                    color="primary" 
                    className={classes.checkoutButton}
                    endIcon={<ArrowForwardIosIcon style={{ fontSize: 14 }} />}
                    onClick={toggleDrawer(true)}
                    disabled={listItens.length === 0}
                >
                    Pagar
                </Button>
            </Paper>

            <Drawer 
                anchor="bottom" 
                open={drawerOpen} 
                onClose={toggleDrawer(false)}
                classes={{ paper: classes.drawerPaper }}
            >
              {drawerOpen && (
                <>
                  <div className={classes.drawerHeader}>
                      <Typography variant="h6" color="primary">Checkout</Typography>
                      <IconButton onClick={toggleDrawer(false)} size="small">
                          <CloseIcon />
                      </IconButton>
                  </div>
                  <Box flexGrow={1} overflow="auto">
                      <SaleSelect
                        options={cartValues}
                        listItens={listItens}
                        selectPlots={selectPlots}
                        selectClient={selectClient}
                        selectPromotion={selectPromotion}
                        setDiscount={setDiscount}
                        selectInterest={selectInterest}
                        changeSearchItens={changeSearchItens}
                        confirmSale={confirmSale}
                        qntd={qntd}
                        setQntd={setQntd}
                        mobile
                      />
                       <Box mt={3} p={2} bgcolor="#f9f9f9" borderRadius={8}>
                          <Grid container justify="space-between">
                              <Typography>Subtotal:</Typography>
                              <Typography>{formattedCurrency(cartValues.totalSum)}</Typography>
                          </Grid>
                          {cartValues.discount > 0 && (
                              <Grid container justify="space-between" style={{ color: '#16A34A', fontWeight: 600 }}>
                                  <Typography>Desconto:</Typography>
                                  <Typography>- {formattedCurrency(cartValues.discount)}</Typography>
                              </Grid>
                          )}
                          <Divider style={{ margin: '8px 0' }} />
                          <Grid container justify="space-between">
                              <Typography variant="h6">TOTAL:</Typography>
                              <Typography variant="h6" color="primary">{formattedCurrency(cartValues.total)}</Typography>
                          </Grid>
                       </Box>
                  </Box>
                  <Button 
                      variant="contained" 
                      color="primary" 
                      fullWidth 
                      size="large"
                      style={{ marginTop: 16, borderRadius: 25, height: 50 }}
                      onClick={confirmSale}
                  >
                      Finalizar Venda
                  </Button>
                </>
              )}
            </Drawer>
        </>
      ) : (
        <div className={classes.desktopWrapper}>
            <Grid container spacing={2} className={classes.desktopGrid}>
                <Grid item xs={12} md={8} style={{ height: '100%' }}>
                    <Paper className={classes.desktopPaper} elevation={1}>
                        <Box className={classes.desktopHeader}>
                            <Typography variant="h6" color="primary">
                                <ShoppingCartIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                                Itens do Pedido ({listItens.length})
                            </Typography>
                        </Box>
                        
                        <Box className={classes.desktopScrollArea}>
                            <TableContainer>
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Qtd</TableCell>
                                            <TableCell>Produto</TableCell>
                                            <TableCell>Valor Un</TableCell>
                                            <TableCell>Total</TableCell>
                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listItens.map((data, index) => {
                                          const calcList = data.typeItem === 'product' ? cartValues.products : cartValues.services;
                                          const calcItem = Array.isArray(calcList)
                                            ? calcList.find((it) => String(it.id) === String(data.id))
                                            : null;
                                          const hasDiscount = calcItem && Number(calcItem.discount) > 0;

                                          return (
                                            <TableRow key={index} hover>
                                                <TableCell width="20%">
                                                    <ComandaQuantityStepper
                                                        amount={data.amount}
                                                        onIncrement={() => {
                                                            const currentAmt = Number(data.amount || 0);
                                                            editItem(index, Math.round((currentAmt + 1) * 1000) / 1000);
                                                        }}
                                                        onDecrement={() => {
                                                            const currentAmt = Number(data.amount || 1);
                                                            if (currentAmt > 1) {
                                                                editItem(index, Math.round((currentAmt - 1) * 1000) / 1000);
                                                            } else {
                                                                setItemToRemove({ index, name: data.name });
                                                            }
                                                        }}
                                                        onCommit={(newQty) => {
                                                            editItem(index, newQty);
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                  <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
                                                    <span>{data.name}</span>
                                                    {hasDiscount && (
                                                      <span
                                                        style={{
                                                          fontSize: '0.72rem',
                                                          backgroundColor: '#E8F5E9',
                                                          color: '#2E7D32',
                                                          padding: '2px 6px',
                                                          borderRadius: 4,
                                                          fontWeight: 600,
                                                        }}
                                                      >
                                                        -{formattedCurrency(calcItem.discount)}
                                                      </span>
                                                    )}
                                                  </div>
                                                </TableCell>
                                                <TableCell>{formattedCurrency(data.valueUn)}</TableCell>
                                                <TableCell>
                                                  {hasDiscount ? (
                                                    <div>
                                                      <span
                                                        style={{
                                                          textDecoration: 'line-through',
                                                          color: '#9E9E9E',
                                                          fontSize: '0.8rem',
                                                          marginRight: 6,
                                                        }}
                                                      >
                                                        {formattedCurrency(data.valueTotal)}
                                                      </span>
                                                      <span style={{ fontWeight: 700, color: '#1B5E20' }}>
                                                        {formattedCurrency(calcItem.total)}
                                                      </span>
                                                    </div>
                                                  ) : (
                                                    <span style={{ fontWeight: 'bold' }}>{formattedCurrency(data.valueTotal)}</span>
                                                  )}
                                                </TableCell>
                                                <TableCell align="center">
                                                    <IconButton size="small" onClick={() => setItemToRemove({ index, name: data.name })} color="secondary">
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <Box className={classes.desktopFooter}>
                            <UIFormContainerSale
                                sale={salesInfo}
                                data={cartValues}
                                onConfirmed={confirmSale}
                            />
                        </Box>
                    </Paper>
                </Grid>
                
                <Grid item xs={12} md={4} style={{ height: '100%' }}>
                    <Paper className={classes.desktopPaper} elevation={3} style={{ backgroundColor: '#fafafa' }}>
                        <Box className={classes.desktopHeader}>
                            <Typography variant="h6" color="primary">
                                <PaymentIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                                Pagamento
                            </Typography>
                        </Box>
                        
                        <Box p={2} className={classes.desktopScrollArea}>
                            <SaleSelect
                              options={cartValues}
                              listItens={listItens}
                              selectPlots={selectPlots}
                              selectClient={selectClient}
                              selectPromotion={selectPromotion}
                              setDiscount={setDiscount}
                              selectInterest={selectInterest}
                              changeSearchItens={changeSearchItens}
                              confirmSale={confirmSale}
                              qntd={qntd}
                              setQntd={setQntd}
                            />
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </div>
      )}

      {modalSearch && (
        <SaleSearchItem
          open={modalSearch}
          mobile={mobile}
          handleModal={changeSearchItens}
          selectItem={selectItem}
          listItems={calculate}
        />
      )}
      {modalConfirm && (
        <SaleConfirm
          open={modalConfirm}
          options={cartValues}
          calculate={calculate}
          setOptions={setCartValues}
          handleModal={() => setModalConfirm(!modalConfirm)}
          handleModalSale={handleModalSale}
          refreshCards={refreshCards}
          resetform={resetform}
          mobile={mobile}
        />
      )}
      <UIDialogConfirm
        open={alertList}
        data={salesInfo}
        timeSucess={3000}
        messageSucess="Ação realizada com sucesso!"
        close={() => setAlertList(!alertList)}
        setrequestinfo={setSaleInfo}
      />

      {/* Modal de Confirmação de Exclusão de Item */}
      <Dialog
        open={Boolean(itemToRemove)}
        onClose={() => setItemToRemove(null)}
        PaperProps={{
          style: {
            borderRadius: 14,
            padding: '8px',
            maxWidth: '360px',
          },
        }}
      >
        <DialogTitle style={{ fontWeight: 700, paddingBottom: 4 }}>
          Remover item?
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ fontSize: '0.9rem', color: '#475569' }}>
            Tem certeza que deseja remover <strong>"{itemToRemove?.name}"</strong> da comanda?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: '8px 16px 12px 16px' }}>
          <Button
            onClick={() => setItemToRemove(null)}
            color="default"
            style={{ textTransform: 'none', fontWeight: 600 }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmRemove}
            variant="contained"
            style={{
              backgroundColor: '#ef4444',
              color: '#ffffff',
              textTransform: 'none',
              fontWeight: 700,
            }}
          >
            Remover
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SaleNew;